import {tableHeaderStylesType} from './model'

export const tableHeaderStyles: tableHeaderStylesType[] = [
  {label: 'Shift', style: {padding: '1rem', fontSize: '1.2rem', width: '18%'}},
  {
    label: 'Checkpoints',
    style: {
      padding: '1rem',
      fontSize: '1.2rem',
    },
  },
  {label: 'No. of expected Scans', style: {padding: '1rem', fontSize: '1.2rem'}},
  {
    label: 'No. of Successful Scans',
    style: {padding: '1rem', fontSize: '1.2rem', backgroundColor: '#01AF4E', color: '#fff'},
  },
  {
    label: 'No. of Missed Scans',
    style: {padding: '1rem', fontSize: '1.2rem', backgroundColor: '#BE0201', color: '#fff'},
  },
  {label: 'Success Scan %', style: {padding: '1rem', fontSize: '1.2rem'}},
]
